import { Check } from "lucide-react";
import { Icon } from "./Icon";
import { cx } from "./cx";

export interface StepIndicatorProps {
  /** Default ["Verify", "Set password", "Done"]. Keep to 3–4 short labels. */
  steps?: string[];
  /** 0-based. Steps before it show a tick. */
  current: number;
  className?: string;
}

/** Where the customer is in a short linear flow. Not navigation: steps can't be clicked, and
 *  going back is a link in the screen. */
export function StepIndicator({ steps = ["Verify", "Set password", "Done"], current, className }: StepIndicatorProps) {
  return (
    <ol aria-label={`Step ${current + 1} of ${steps.length}`} className={cx("m-0 flex list-none p-0", className)}>
      {steps.map((step, index) => {
        const done = index < current;
        const now = index === current;
        const last = index === steps.length - 1;
        return (
          <li key={step} aria-current={now ? "step" : undefined} className={cx("flex min-w-0 flex-col gap-1.5", last ? "flex-none" : "flex-1")}>
            <span className="flex items-center">
              <span
                className={cx(
                  "flex size-6 flex-none items-center justify-center rounded-full border-2 type-label text-[12px]",
                  done ? "border-green-700 bg-green-700 text-white" : now ? "border-green-700 bg-surface-card text-green-800" : "border-ink-300 bg-surface-card text-ink-400",
                )}
              >
                {done ? <Icon icon={Check} size={14} strokeWidth={3} /> : index + 1}
              </span>
              {!last && <span className={cx("mx-2 h-0.5 flex-1 rounded-[1px]", done ? "bg-green-700" : "bg-border-default")} />}
            </span>
            <span className={cx("whitespace-nowrap type-small", now ? "font-semibold text-text-strong" : done ? "text-text-body" : "text-text-muted")}>
              {step}
              <span className="sr-only">{done ? ", done" : now ? ", current step" : ""}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
